import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import {
	Button,
	Form,
	Row,
	Field,
	Select,
	RelationSelect,
	Attachments,
	ManyToManySelect,
	DatePicker,
} from '@smartplatform/ui';
import { Editor } from '../../components';
import { groups, LAW } from '../documents/groups';

import store from '../../store';
import './style.scss';
import { withRouter } from 'react-router-dom';

@withRouter
@observer
export default class Edit extends React.Component {
	@observable record = null;
	@observable error = null;
	@observable group = LAW;
	@observable attachmentIsnance;
	@observable addDocument;
	@observable allRoles;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.id = this.props.match.params.id;
		// console.log('this.id', this.id);
		if (!isNaN(this.id)) {
			try {
				this.record = await store.model.Discussion.findById(this.id, {
					include: [
						{
							relation: 'document',
						},
						{
							relation: 'comments',
							scope: {
								where: { sended: true },
								include: {
									relation: 'attachments',
								},
							},
						}
					],
				});
				this.group = this.record.docGroup;
				this.record.documentId && (this.addDocument = true);
			} catch (e) {
				this.error = e.message;
			}
		} else {
			this.record = new store.model.Discussion();
		}
	};
	onGroupChange = group => {
		this.group = group;
	};

	docName = document =>
		document ? (
			<span title={document.id}>
				{document.freeNum}: {document.name}
			</span>
		) : (
			''
		);

	togglecomment = async (e, comment) => {
		comment.publish = e.target.checked;
		await comment.save();
	};

	toggleAddDocument = () => {
		this.addDocument = !this.addDocument;
	};

	beforeSave = async record => {
		if (record.id) {
			!this.addDocument && (record.documentId = null);
			this.poll && (await this.poll.save());
			await record.save();
		}
	};

	onSave = record => {
		const { id } = this.props;
		if (!id) {
			this.props.history.push(`/admin/discussions/${record.id}/discussion`);
		}
		if (!this.addDocument) {
			this.record.document = null;
			this.record.documentId = null;
			this.record.save();
		}
	};
	render() {
		if (!this.record) {
			return <div>...</div>;
		}
		const _groups = Object.keys(groups).map(key => ({ label: groups[key], value: key }));

		const documents = this.addDocument && (
			<>
				<div className="form-field">
					<label>Вид документа</label>
					<Select items={_groups} value={this.group} onChange={this.onGroupChange} />
				</div>
				<Field relation="document" property="name" label="Обсуждаемый законопроект">
					<RelationSelect
						filter={{
							where: {
								and: [{ docGroup: this.group }, { name: { neq: '' } }],
							},
							order: 'id desc',
						}}
						// eslint-disable-next-line
						searchFields={['freeNum', name]}
						likeOperator="like"
						computed={this.docName}
					/>
				</Field>
			</>
		);

		return (
			<div className="discussion-edit">
				<p>Страница</p>
				<Form record={this.record} rootPath="/admin" returnTo="/admin/discussions" onSave={this.onSave} stay>
					<Field property="name" label="Заголовок" />
					<Button
						className={this.addDocument ? 'btn-danger' : 'btn-primary'}
						label={`${this.addDocument ? 'Убрать' : 'Добавить'} документ для обсуждения`}
						onClick={this.toggleAddDocument}
					/>
					{documents}
					<div className="article__edit-content">
						<p>Описание</p>
						<Editor
							value={this.record.text}
							onChange={content => (this.record.text = content)}
							mediaModel={store.model.Image}
							height={600}
							filesUploadData={{
								record: this.record,
								relation: 'attachments',
								property: 'filename',
								onEnd: () => this.attachmentIsnance && this.attachmentIsnance.reload(),
							}}
						/>
					</div>
					{this.record.id ? (
						<>
							<Attachments
								record={this.record}
								relation="attachments"
								store={store.model}
								instance={instance => (this.attachmentIsnance = instance)}
							/>
						</>
					) : (
						<div>
							<h3>Cоздайте обсуждение, чтобы добавить приложния и голосование </h3>
						</div>
					)}
					<div>
						<label>Настройка видимости</label>
						<Row>
							<Field property="allRoles" label="Все" />
							{!this.record.allRoles && <Field property="registeredOnly" label="Зарегистрированные" />}
							{!this.record.registeredOnly && !this.record.allRoles ? (
								<Field property="roles" label="Для ролей">
									<ManyToManySelect relation="roles" property="name" itemTag={f => f.name} noSearch={true} />
								</Field>
							) : (
								<div/>
							)}
						</Row>
					</div>
					<Row>
						<Field property="publish" label="Опубликовать" />
						<Field property="startDate" label="Начало обсуждения">
							<DatePicker showTimeSelect timeIntervals={15} />
						</Field>
						<Field property="endDate" label="Конец обсуждения">
							<DatePicker showTimeSelect timeIntervals={15} />
						</Field>
					</Row>
				</Form>
			</div>
		);
	}
}
